import { render, staticRenderFns } from "./BrandFilterTreeView.vue?vue&type=template&id=3a87c082&scoped=true&"
import script from "./BrandFilterTreeView.vue?vue&type=script&lang=ts&"
export * from "./BrandFilterTreeView.vue?vue&type=script&lang=ts&"
import style0 from "./BrandFilterTreeView.vue?vue&type=style&index=0&id=3a87c082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87c082",
  null
  
)

export default component.exports